import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import LocalStorage from "../LocalStorage/LocalStorage";

const Chatbot = (props) => {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const [chatbotWidth, setChatbotWidth] = useState(isMobile ? viewportWidth : 600);
    const [chatbotHeight, setChatbotHeight] = useState(isMobile ? viewportHeight : viewportHeight);
    const [connectionMade, setConnectionMade] = useState(false);
    const mfrId = LocalStorage.manufacturerData.get().platform_id;
    const authToken = LocalStorage.authKey.get();
    const isAdmin = LocalStorage.userData.get().user.internalAdmin;

    const handleChatBotConnection = (event) => {
        if (event.data === 'chatbotHandshake') {
            setConnectionMade(true);
            event.source.postMessage('chatbotConnectionMade', event.origin);
        }
        if (event.data === 'chatbotReadyForData') {
            event.source.postMessage(
                {
                    authToken: authToken, 
                    platformId: mfrId, 
                    sessionId: authToken, 
                    internalUser: isAdmin, 
                    user_email: LocalStorage.userData.get().user.email,
                    platform: props.platform,
                    botType: props.chatbotType, 
                    forceMobileView: 'false', 
                    hideExpandIcon: 'false', 
                    headerColor: props.headerColor ?? '', 
                    showHeaderLogo: props.showHeaderLogo ?? '', 
                    erniIconBackground: props.erniIconBackground ?? '', 
                    erniIcon: props.erniIcon ?? '', 
                    logo: props.logo ?? '',
                }, 
                event.origin);
        }
    }

    const handleChatbotChangeSize = (event) => {
        if (event.data === 'expandChatbotWindow') {
            setChatbotWidth(window.innerWidth);
            setChatbotHeight(window.innerHeight);
        }
        if (event.data === 'shrinkChatbotWindow') {
            setChatbotWidth(600);
            setChatbotHeight(window.innerHeight);
        }
    }

    window.addEventListener('message', handleChatbotChangeSize);

    useEffect(() => {
        if (!connectionMade) {
            window.addEventListener("message", handleChatBotConnection);
            setConnectionMade(true);
            console.log("🚀 ~ Chatbot event listener attached");
        }
        return () => window.removeEventListener("message", handleChatBotConnection);
        // eslint-disable-next-line
    }, []);

    return (
        <div id='chatbotContainer' style={{position: 'fixed', right: '0px', bottom: '-7px', zIndex: '201', visibility: 'hidden'}}>
            <iframe src={process.env.REACT_APP_CHATBOT_FRONTEND_URL} height={chatbotHeight} width={chatbotWidth} title="Chatbot" id='chatbotIframe' allow="clipboard-read; clipboard-write" style={{background: 'white', boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.25)', border: 'white solid 4px', transition: 'height 0.75s, width 0.75s'}}></iframe>
        </div>
    )
}

export default Chatbot;